import React from 'react';
import './TrendingDestinations.css';

export default function TrendingDestinations() {
  const destinations = [
    { name: 'Mumbai', emoji: '🇮🇳', image: '/assets/244915029.jpg' },
    { name: 'Goa', emoji: '🇮🇳', image: '/assets/438349362.webp' },
    { name: 'Jaipur', emoji: '🇮🇳', image: '/assets/559654140.webp' },
    { name: 'Delhi', emoji: '🇮🇳', image: '/assets/780542900.webp' },
    { name: 'Manali', emoji: '🇮🇳', image: '/assets/1000078.jpg' },
    { name: 'Udaipur', emoji: '🇮🇳', image: '/assets/990511.jpg' },
  ];

  return (
    <section className="block">
      <div className="container">
        <div className="section-head">
          <h2>Trending destinations</h2>
          <p className="sub">Travellers searching for India also booked these</p>
        </div>
        <div className="grid grid-3">
          {destinations.map((dest, idx) => (
            <div key={idx} className="dest-card">
              <div className="dest-label">
                <div className="name">
                  {dest.name} {dest.emoji}
                </div>
              </div>
              <div className="imgslot" data-label={dest.image}>
                <img src={dest.image} alt={dest.name} onError={(e) => (e.target.style.display = 'none')} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
